class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
    this.fetchProducts = this.fetchProducts.bind(this);
    this.initGlide = this.initGlide.bind(this);
  }

  connectedCallback() {
    this.fetchProducts();
  }

  fetchProducts() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const source = html.querySelector("#recommendations_glide_container");
        const destination = this.querySelector(
          "#recommendations_glide_container"
        );
        console.log("source", source);
        console.log("destination", destination);
        console.log(this);
        if (source && destination) {
          destination.outerHTML = source.outerHTML;
        }
        this.initGlide();
      })
      .catch((e) => {
        console.error("Error fetching recommendations:", e);
        // Initialize Glide even if fetch fails
        this.initGlide();
      });
  }

  initGlide() {
    const glideElement = this.querySelector("#recommendations_glide");
    if (!glideElement) return;

    // Check if Glide is already initialized
    if (glideElement.glideInstance) {
      return;
    }

    const glide = new Glide("#recommendations_glide", {
      type: "slider",
      startAt: 0,
      perView: 3,
      bound: true,
      focusAt: "0",
      breakpoints: {
        1300: {
          perView: 2.5,
        },
        992: {
          perView: 2,
        },
        768: {
          perView: 1.5,
        },
        600: {
          perView: 1,
          autoplay: 5000,
        },
      },
    });

    const slides = this.querySelectorAll(
      "#recommendations_glide > div > ul.glide__slides>  li.glide__slide"
    );
    const progressBar = this.querySelector(
      ".solstice__product-recommendations-loading-bar-inside"
    );

    if (progressBar && slides.length > 0) {
      glide.on(["mount.after", "resize"], () => {
        const currentPerView = glide.settings.perView;
        const allSlidesNumber = Math.max(0, slides.length - currentPerView);

        if (allSlidesNumber > 0) {
          const percentage = Math.min(
            100,
            ((glide.index + 1) / (allSlidesNumber + 1)) * 100
          );
          progressBar.style.width = percentage + "%";
        } else {
          progressBar.style.width = "100%";
        }
      });

      glide.on("move.after", () => {
        const currentPerView = glide.settings.perView;
        const allSlidesNumber = Math.max(0, slides.length - currentPerView);
        if (allSlidesNumber > 0) {
          const percentage = Math.min(
            100,
            ((glide.index + 1) / (allSlidesNumber + 1)) * 100
          );

          progressBar.style.width = percentage + "%";
        }
      });
    }

    glide.mount();
    glideElement.glideInstance = glide;
  }
}

if (!customElements.get("recommended-products")) {
  customElements.define("recommended-products", RecommendedProducts);
}
